import React from "react"
import "./color.css"

const Marked = () => {
	return (
		<svg className="marked" width="24" height="24" viewBox="0 0 24 24">
			<g id="Outlined" transform="translate(-882 -198)">
				<g id="Action" transform="translate(100 100)">
					<g
						id="Outlined-_-Action-_-done"
						data-name="Outlined-/-Action-/-done"
						transform="translate(782 98)"
					>
						<g id="Group_153" data-name="Group 153">
							<path id="Path" d="M0,0H24V24H0Z" fill="none" fillRule="evenodd" />
							<path
								id="_-Icon-Color"
								data-name="🔹-Icon-Color"
								d="M9,16.2,4.8,12,3.4,13.4,9,19,21,7,19.6,5.6Z"
								fill="#88c8bc"
								fillRule="evenodd"
							/>
						</g>
					</g>
				</g>
			</g>
		</svg>
	)
}

export default Marked
